import { useTranslation } from 'react-i18next';

interface PlaceholderProps {
  titleKey: string;
  path: string;
  icon?: string;
}

interface CardDef {
  icon: string;
  titleKey: string;
  descKey: string;
}

const CARDS: readonly CardDef[] = [
  { icon: 'api', titleKey: 'placeholder.card_api_title', descKey: 'placeholder.card_api_desc' },
  {
    icon: 'design_services',
    titleKey: 'placeholder.card_design_title',
    descKey: 'placeholder.card_design_desc',
  },
  {
    icon: 'translate',
    titleKey: 'placeholder.card_i18n_title',
    descKey: 'placeholder.card_i18n_desc',
  },
  {
    icon: 'lock',
    titleKey: 'placeholder.card_perm_title',
    descKey: 'placeholder.card_perm_desc',
  },
  {
    icon: 'cloud_off',
    titleKey: 'placeholder.card_offline_title',
    descKey: 'placeholder.card_offline_desc',
  },
  {
    icon: 'verified',
    titleKey: 'placeholder.card_test_title',
    descKey: 'placeholder.card_test_desc',
  },
] as const;

export function PlaceholderRoute({ titleKey, path, icon = 'construction' }: PlaceholderProps) {
  const { t } = useTranslation();
  const title = t(titleKey);
  const slug = path.replace(/^\//, '') || 'home';

  return (
    <div className="route-placeholder">
      <div className="route-card route-card-hero">
        <div className="route-card-icon">
          <span className="material-symbols-outlined">{icon}</span>
        </div>
        <h2>{title}</h2>
        <p>
          {t('placeholder.hero_intro')} · <code>{path}</code>
        </p>
      </div>
      {CARDS.map((c) => (
        <div key={c.titleKey} className="route-card">
          <div className="route-card-icon">
            <span className="material-symbols-outlined">{c.icon}</span>
          </div>
          <h3>{t(c.titleKey)}</h3>
          <p>{t(c.descKey, { slug })}</p>
        </div>
      ))}
    </div>
  );
}
